'use client';
import { useRegionStore } from '../stores/region-store.mjs';

// src/hooks/use-toast.ts
var useToast = () => {
  const storeShow = useRegionStore((state) => state.show);
  const show = (item) => storeShow({ type: "toast", ...item });
  return show;
};
var use_toast_default = useToast;

export { use_toast_default as default };
